import { AlertModalModel } from "../../../models/AlertModal.model";

export const SET_ALERT = 'SET_ALERT';

export interface SetAlert {
    type: typeof SET_ALERT;
    payload: {
        alert: AlertModalModel;
    };
}

export type AlertDispatchType = SetAlert;